/* Handing a file to the person at the keyboard.
 *
 * A blob URL rather than a data URI: a data URI of a 555 row workbook is a
 * string of a few hundred kilobytes, and some browsers refuse to navigate to
 * one past a size limit that nobody publishes.
 *
 * Revoked on a timer rather than immediately. Revoke in the same tick and the
 * download is cancelled before it starts in some browsers, which looks exactly
 * like a button that does nothing.
 */
export function download(bytes, filename, type) {
  const blob = new Blob([bytes], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const XLSX_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/* A filename someone can find again in a downloads folder holding forty of
   them. Contract, what it is, and the date it was taken. */
export function exportName(contract, what, ext) {
  const who = String(contract?.name ?? "Contract")
    .replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "-").slice(0, 40) || "Contract";
  const when = new Date().toISOString().slice(0, 10);
  return `${who}-${what}-${when}.${ext}`;
}
